import { faCircleInfo } from '@fortawesome/pro-light-svg-icons'
import {
  OwnershipType,
  ResidentialApartmentPropertyDetails,
  ResidentialCondoOwnershipDetails,
  ResidentialPropertyForSaleListing,
  ResidentialType,
} from '@unreserved-frontend-v2/api/generated/graphql/types'
import {
  DETAILS_TABLE_BOOLEAN_FIELDS,
  DetailsTableRow,
  DetailsTableBooleanFieldConfig,
} from '@unreserved-frontend-v2/ui/details-table/models'
import { emptyDefault } from '@unreserved-frontend-v2/utils/empty-default'
import useTranslation from 'next-translate/useTranslation'
import { useMemo } from 'react'

export const useCondoPoliciesRow = (listing: ResidentialPropertyForSaleListing): DetailsTableRow | undefined => {
  const { t } = useTranslation()
  return useMemo(() => {
    if (listing.ownershipDetails?.ownershipType === OwnershipType.Freehold) {
      return
    }

    const details = listing.ownershipDetails as ResidentialCondoOwnershipDetails | null

    let petsAllowed: DetailsTableBooleanFieldConfig | null = null

    if (details?.petsAllowed != null) {
      petsAllowed = DETAILS_TABLE_BOOLEAN_FIELDS[details.petsAllowed ? 'yes' : 'no']
    }

    let shortTermAllowed: DetailsTableBooleanFieldConfig | null = null

    if (listing.propertyDetails?.residentialType === ResidentialType.Apartment) {
      const details = listing.propertyDetails as ResidentialApartmentPropertyDetails | null
      if (details?.building && details?.building?.shortTermRentalPolicy !== null) {
        shortTermAllowed = DETAILS_TABLE_BOOLEAN_FIELDS[details.building.shortTermRentalPolicy ? 'yes' : 'no']
      }
    }

    if (petsAllowed === null && shortTermAllowed === null) {
      return
    }

    return {
      icon: faCircleInfo,
      title: t('listings:details-pages.condo-policies'),
      cells: [
        {
          id: 'pets',
          data: [
            {
              id: 'data-pets',
              label: t('listings:details-pages.pets-allowed'),
              value: emptyDefault(petsAllowed?.key ? t(petsAllowed.key) : null),
              icon: petsAllowed?.icon,
            },
          ],
        },
        {
          id: 'shortterm',
          data: [
            {
              id: 'data-shorterm',
              label: t('listings:details-pages.short-term-rental'),
              value: emptyDefault(shortTermAllowed?.key ? t(shortTermAllowed?.key) : ''),
              icon: shortTermAllowed?.icon,
            },
          ],
        },
      ],
    }
  }, [t, listing])
}
